<div class="sa-custom">
  <div class="sa-custom-wrapper">
    <sa-icon icon="saras_logo" size="44"></sa-icon>

    <div class="flex-center h-100">
      @if(messageView){
      <sa-message-view
        [props]="messageView"
        (onClick)="onMessageViewEvent($event)"
      ></sa-message-view>
      }
    </div>
  </div>
</div>
